
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/converter/sketch-to-ai",
      function () {
        return require("private-next-pages/converter/sketch-to-ai.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/converter/sketch-to-ai"])
      });
    }
  